@if (show) {
<div class="modal-confirmation-overlay" (click)="cancel()"></div>
}

<div class="modal-confirmation-container">
  @if (show) {
  <button type="button" class="btn btn-danger confirmation-button" (click)="confirm()">{{ message }}</button>
  }
  <ng-content></ng-content>
</div>
